import { useSearchParams } from 'react-router-dom';

/**
 * Whether the in-class overlay panels should render.
 *
 * The overlays (student names spoken, student interaction, teacher pace meter,
 * AI assistant) each drive their own 10s poll against lms-backend. The only
 * client that ever rendered them was the egress recorder — the parent and
 * tutor-manager views already hide them — so they accounted for ~1.2M requests
 * and ~28% of lms-backend request wall time during a peak window, purely to
 * burn the panels into the recorded MP4.
 *
 * They are therefore off by default. Pass `?panels=true` on the recording app
 * URL to opt a session back in.
 */
const useOverlayPanels = (): boolean => {
  const [searchParams] = useSearchParams();

  return searchParams.get('panels')?.toLowerCase() === 'true';
};

export default useOverlayPanels;
